import React from "react";
import "./VideoCard.css";

const VideoCard = ({ video, onView }) => {
  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onView(video);
    }
  };

  return (
    <article
      className="video-card"
      onClick={() => onView(video)}
      onKeyDown={handleKeyDown}
      tabIndex="0"
      role="button"
      aria-label={`View project: ${video.title}`}
    >
      <div className="video-thumbnail">
        <img
          src={`https://img.youtube.com/vi/${video.videoId}/hqdefault.jpg`}
          alt={`${video.title} video thumbnail`}
          loading="lazy"
        />

        <div className="play-overlay" aria-hidden="true">
          <span className="play-icon">▶</span>
        </div>

        <span className="video-duration">{video.duration}</span>
      </div>

      <div className="video-info">
        <h3>{video.title}</h3>

        <p>{video.description}</p>

        <div className="video-meta">
          <span className="category">{video.category}</span>

          <span className="year">{video.year}</span>
        </div>
      </div>
    </article>
  );
};

export default VideoCard;
